import { icons } from "../../assets/icons";

export const sidebarOptions = [
  {
    icon: icons.groupIcon,
    title: "Groups",
    link: "/groups",
  },
  {
    icon: icons.userIcon,
    title: "Users",
    link: "/users",
  },
  // {
  //   icon: icons.roleIcon,
  //   title: "Roles",
  //   link: "/roles",
  // },
  {
    icon: icons.uploadConfigIcon,
    title: "Upload Config",
    link: "/uploadConfig",
  },
  {
    icon: icons.userIcon,
    title: "User Data",
    link: "/userData",
  }
];
